<!-- <div *ngIf="!isHidden" fxLayout="row" [ngClass]="layout">
<forge-button variant="link" (click)="executeAction($event)" [disabled]="isViewOnly" attr.telemetry="Submission-{{Text}}" (keydown)="handleKeyDown($event)">
  {{Text}}
</forge-button>
</div> -->

@if (!isHidden && Text) {
  <div fxLayout="row" [ngClass]="layout">
    <a class="link-container" [id]="id" role="link" (click)="executeAction($event)" [disabled]="isViewOnly" attr.telemetry="Submission-{{Text}}" (keydown)="handleKeyDown($event, true)" tabindex="0">
      {{Text}}
      <forge-focus-indicator [attr.target]="id"></forge-focus-indicator>
    </a>
  </div>
}